<template>
    <div class="org-select-pop">
        <v-popconfirm
            ref="selectPop"
            :use-arrow="useArrow"
            clazz="org-select-pop-box"
            @confirm="onConfirm"
            @visibleChange="onVisibleChange"
        >
            <org-select-inner
                ref="inner"
                :show="showInner"
                v-bind="$attrs"
                @change="onChange"
            />
            <span
                v-if="showAdditionalFooter"
                slot="additional-footer"
                class="org-select-pop-opt"
            >
                <a
                    href="javascript:;"
                    @click.prevent="selectAll"
                >{{ $t('全选') }}</a>
                <a
                    href="javascript:;"
                    @click.prevent="clear"
                >{{ $t('清空') }}</a>
            </span>
        </v-popconfirm>
        <span
            v-popconfirm:selectPop
            class="org-select-trigger"
        >
            <slot name="trigger">
                <div class="org-select-trigger-dropdown">
                    <div class="org-select-trigger-info">
                        <span class="org-select-trigger-res">{{ showResTxt }}</span>
                        <span class="org-select-trigger-num">{{ showNumTxt }}</span>
                    </div>
                    <v-icon
                        name="v-arrow_dropdown"
                        class="org-select-trigger-arrow"
                    />
                </div>
            </slot>
        </span>
    </div>
</template>

<script>
import OrgSelectInner from './org-select-inner';
import OrgSelectMixin from './mixins';

export default {
  components: {
    OrgSelectInner,
  },
  mixins: [OrgSelectMixin],
  props: {
    dropdwonPlaceholder: {
      type: String,
      default: '',
    },

    resTxt: {
      type: String,
      default: '',
    },

    useArrow: {
      type: Boolean,
      default: true,
    },

    showAdditionalFooter: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      preTxt: '',
      numTxt: '',
    };
  },

  computed: {
    showResTxt() {
      const nameArr = this.confirmSelectedArr.map(item => item.name);
      let txt = '';

      if (nameArr.length > 0) {
        txt = `${this.preTxt}${nameArr.join(',')}`;
      } else {
        txt = this.dropdwonPlaceholder || this.$t('请选择');
      }

      return txt;
    },

    showNumTxt() {
      let txt = '';

      if (this.numTxt && this.confirmSelectedArr.length && this.confirmSelectedArr.length > 1) {
        txt = this.numTxt.replace('$num', this.confirmSelectedArr.length);
      }
      return txt;
    },
  },

  created() {
    this.setResTxt();
  },

  methods: {
    onVisibleChange(val) {
      if (val) {
        this.onShow();
      }
    },

    selectAll() {
      this.$refs.inner.getTree().selectAll();
    },

    clear() {
      this.$refs.inner.getTree().clear();
    },

    setResTxt() {
      const arr = this.resTxt.split('$res');
      this.confirmSelectedArr = this.$attrs.selected || [];

      [this.preTxt, this.numTxt] = arr;
    },
  },
};
</script>
